import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from "prop-types";
import { Flex } from "@base-ui/containers";
import { Label, Input } from "./dateInput.styles";
import { extendedSystemStylesProps } from "@mixins";
import { getIsoDate } from "utils/dates";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];
var DateInput = function DateInput(props) {
  var id = props.id,
    label = props.label,
    value = props.value,
    _onChange = props.onChange,
    disabled = props.disabled,
    hideLabel = props.hideLabel,
    className = props.className,
    inverted = props.inverted;
  return /*#__PURE__*/_jsxs(Flex.Column, _objectSpread(_objectSpread({
    className: className
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: [/*#__PURE__*/_jsx(Label, {
      htmlFor: id,
      disabled: disabled,
      hideLabel: hideLabel,
      children: label
    }), /*#__PURE__*/_jsx(Input, {
      type: "date",
      id: id,
      inverted: inverted,
      disabled: disabled,
      onChange: function onChange(e) {
        return _onChange(e.target.value || null);
      },
      value: getIsoDate(value) || ""
    })]
  }));
};
DateInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  hideLabel: PropTypes.bool,
  className: PropTypes.string
};
export default DateInput;